/* cs-buybox.js - CineStore 3.0 buy-box certainty engine (Step 1.4).
   Reads per-variant data rendered by snippets/cs-buybox.liquid and shows:
   dual ex/inc VAT (only when variant taxable + UK market), RRP + savings,
   live stock state, a same-day-dispatch countdown to the 2pm cutoff, and an
   honest "arrives as early as" date that skips weekends/bank-holidays/closures.
   Backorder (tracked + continue-selling + qty <= 0): shows "Available to order"
   and hides the dispatch + arrival rows (restock lead time is not in our control).
   ex/inc headline follows the site-wide VAT toggle (html.cs-vat-inc + 'cs:vat' event).
   RRP renders on its own line above the price and follows the same ex/inc toggle.
   Re-resolves on variant change via the product form [name="id"]. No core edits. */
(function () {
  function init(root) {
    var dataEl = root.querySelector('[data-cs-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var cfg = {
      vatRate: parseFloat(root.getAttribute('data-vat-rate') || '0.2'),
      uk: root.getAttribute('data-uk') === '1'
    };
    /* Dispatch/arrival timing (2pm UK cutoff, closures, weekend skipping) comes
       from the shared engine assets/cs-ship.js so this page and the homepage Crew
       Favourites bar stay in lockstep and both measure the cutoff in UK time. */
    var ship = window.CSShip;
    var q = function (s) { return root.querySelector(s); };
    var els = {
      now: q('[data-cs-price-now]'), vatLab: q('[data-cs-vatlabel]'), wasRow: q('[data-cs-wasrow]'), rrp: q('[data-cs-rrp]'), save: q('[data-cs-save]'),
      second: q('[data-cs-secondprice]'), vatSwitch: q('[data-cs-vatswitch]'),
      stockRow: q('[data-cs-stockrow]'), stockTxt: q('[data-cs-stock]'),
      dispRow: q('[data-cs-disprow]'), dispTxt: q('[data-cs-dispatch]'),
      arrRow: q('[data-cs-arrrow]'), arrTxt: q('[data-cs-arrival]')
    };
    var mode = document.documentElement.classList.contains('cs-vat-inc') ? 'inc' : 'ex';
    /* Write innerHTML only when it actually changed. render() runs every second
       for the countdown; unconditional writes rebuilt identical nodes each tick,
       which killed :hover on the *estimated tooltip (visible flashing). */
    function setHTML(el, html) { if (el && el.csHtml !== html) { el.csHtml = html; el.innerHTML = html; } }
    function money(p) { return '£' + (p / 100).toFixed(2); }
    function currentVariant() {
      var id = null;
      var form = root.closest('form') || document.querySelector('form[action*="/cart/add"]');
      if (form) { var inp = form.querySelector('[name="id"]'); if (inp) id = inp.value; }
      if (!id) { id = new URLSearchParams(location.search).get('variant'); }
      if (id && variants[id]) return variants[id];
      var k; for (k in variants) { if (variants[k].available) return variants[k]; }
      for (k in variants) { return variants[k]; }
      return null;
    }
    function render() {
      var v = currentVariant(); if (!v) return;
      var showInc = v.taxable && cfg.uk;
      var ex = money(v.price), inc = money(Math.round(v.price * (1 + cfg.vatRate)));
      setHTML(els.now, (mode === 'inc' && showInc) ? inc : ex);
      if (els.vatLab) els.vatLab.textContent = (mode === 'inc' && showInc) ? 'inc VAT' : (v.taxable ? 'ex VAT' : 'no VAT');
      if (els.rrp && els.save) {
        if (v.rrp && v.rrp > v.price) {
          /* RRP is stored ex VAT; follow the same ex/inc toggle as the headline price */
          var rrpShown = (mode === 'inc' && showInc) ? Math.round(v.rrp * (1 + cfg.vatRate)) : v.rrp;
          if (els.wasRow) els.wasRow.style.display = '';
          setHTML(els.rrp, money(rrpShown));
          els.save.style.display = ''; els.save.textContent = 'Save ' + Math.round((1 - v.price / v.rrp) * 100) + '%';
        } else { if (els.wasRow) els.wasRow.style.display = 'none'; els.save.style.display = 'none'; }
      }
      setHTML(els.second, showInc ? (mode === 'inc' ? ('ex VAT ' + ex) : ('inc VAT ' + inc)) : (v.taxable ? '' : 'VAT not charged on this item'));
      if (els.vatSwitch) els.vatSwitch.style.display = 'none';
      var avail = v.available, inv = v.inventory, low = v.lowstock, tracked = v.tracked;
      var backorder = avail && tracked && inv <= 0;
      var state = !avail ? 'out' : (backorder ? 'back' : ((low && inv > 0 && inv <= low) ? 'low' : 'in'));
      if (els.stockRow) els.stockRow.className = 'cs-cbrow cs-stock ' + state;
      if (els.stockTxt) {
        if (state === 'out') setHTML(els.stockTxt, '<b>Out of stock</b>');
        else if (state === 'back') setHTML(els.stockTxt, '<b>Available to order</b> · we dispatch as soon as it is back in stock');
        else if (state === 'low') setHTML(els.stockTxt, '<b>Only ' + inv + ' left</b> · order soon');
        else setHTML(els.stockTxt, '<b>In stock</b>' + (inv > 0 ? (' · ' + (inv > 5 ? '5+' : inv) + ' ready to ship') : ''));
      }
      if (state === 'out' || state === 'back') { if (els.dispRow) els.dispRow.style.display = 'none'; if (els.arrRow) els.arrRow.style.display = 'none'; return; }
      if (els.dispRow) els.dispRow.style.display = ''; if (els.arrRow) els.arrRow.style.display = '';
      if (!ship) { if (els.dispRow) els.dispRow.style.display = 'none'; if (els.arrRow) els.arrRow.style.display = 'none'; return; }
      if (els.dispTxt) setHTML(els.dispTxt, ship.dispatchLineHtml());
      if (els.arrTxt) {
        var arrival = ship.getDispatch().arrival;
        setHTML(els.arrTxt, 'Arrives as early as <b>' + ship.fmt(arrival) + '</b>' +
          '<span class="cs-est">*estimated<span class="cs-tip">' +
          'All delivery timescales are Estimated not Guaranteed. For fastest delivery choose &lsquo;Express&rsquo; delivery at checkout. UK mainland &amp; Working Days only. Standard delivery takes a little longer. ' +
          '<a class="cs-tip-link" href="https://www.cinestore.co.uk/pages/delivery">See more</a></span></span>');
      }
    }
    render();
    setInterval(render, 1000);
    window.addEventListener('cs:vat', function (e) { mode = (e && e.detail === 'inc') ? 'inc' : 'ex'; render(); });
  }
  document.querySelectorAll('[data-cs-buybox]').forEach(init);
})();
